import { z } from 'zod';
import { changeLoginEmailRequestParamsSchema } from './types';
export const changeLoginEmailDef = {
    name: 'changeLoginEmail',
    requestSchema: changeLoginEmailRequestParamsSchema,
    responseSchema: z.void(),
};
